export const SEGMENT_EVENTS = {
  WATCHED_VIDEO: 'Watched Video',
  OPENED_VIDEO_MODAL: 'Opened Video Modal',
  CLOSED_VIDEO_MODAL: 'Closed Video Modal',
  EXPAND_GLOSSARY_ITEM: 'Expand Glossary Item',
  COLLAPSE_GLOSSARY_ITEM: 'Collapse Glossary Item',
  EXPAND_GLOSSARY_ALL_ITEMS: 'Expand Glossary All Items',
  COLLAPSE_GLOSSARY_ALL_ITEMS: 'Collapse Glossary All Items',
  EXPAND_FAQ_ITEM: 'Expand FAQ Item',
  COLLAPSE_FAQ_ITEM: 'Collapse FAQ Item',
  EXPAND_FAQ_ALL_ITEMS: 'Expand FAQ All Items',
  COLLAPSE_FAQ_ALL_ITEMS: 'Collapse FAQ All Items',
  DOWNLOAD_METHODOLOGY: 'Download Methodology',
  OPENED_FOUNDATIONAL_REPORT_MODAL: 'Opened Foundational Report Modal',
  CLOSED_FOUNDATIONAL_REPORT_MODAL: 'Closed Foundational Report Modal',
  CLICKED_FOUNDATIONAL_REPORT_RELATED_TOPIC:
    'Clicked Foundational Report Related Topic',
  DOWNLOAD_FOUNDATION_REPORT: 'Download Foundational Report',
  DOWNLOAD_SECTOR_PRIMER: 'Download Sector Primer',
  VIEW_NAVIGATIONAL_HELPFUL_HINT: 'View Navigational Helpful Hint',
  DOWNLOAD_TECHNICAL_GUIDE: 'Download Technical Guide',
  SEARCH_GLOSSARY: 'Search Glossary',
  SEARCH_GLOSSARY_BY_LETTER: 'Search Glossary By Letter',
  SEARCH_FAQ: 'Search FAQ',
  CLICKED_NEED_A_HAND: 'Clicked Need A Hand',
  SUBMIT_NEED_A_HAND: 'Submit Need A Hand',
  HEADER_SEARCH: 'Header Search',
};
